export function reflow(element: HTMLElement): void {
    element.offsetHeight;
}
